"use client"

import { useEffect, useState } from "react"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/Button"

export function DraftAlertClient({
  isDraftEnabled,
}: {
  isDraftEnabled: boolean
}) {
  const [showDraftAlert, setShowDraftAlert] = useState<boolean>(isDraftEnabled)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    setShowDraftAlert(isDraftEnabled && window.top === window.self)
  }, [isDraftEnabled])

  // Évite les problèmes d'hydratation en n'affichant rien jusqu'au montage côté client
  if (!mounted || !showDraftAlert) {
    return null
  }

  function buttonHandler() {
    void fetch("/api/disable-draft")
    setShowDraftAlert(false)
  }

  return (
    <Alert variant="destructive" className="sticky top-0 left-0 z-50 w-full bg-black border-black text-white">
      <AlertTitle>Draft Mode</AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <span>This page is a draft.</span>
        <Button variant="outline" size="sm" onClick={buttonHandler} className="ml-3 bg-white text-black hover:bg-gray-200">
          Exit draft mode
        </Button>
      </AlertDescription>
    </Alert>
  )
}
